import React, { useEffect, useState } from 'react';
import API from '../API/mainApi';
import '../styles/DriverInfo.css';

const DriverInfo = ({ markerId, onClose }) => {
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!markerId) return;
    const fetchDriver = async () => {
      const data = await API.getDriverByMarkId(markerId);
      if (data.status === 200) {
        setDriver(data.data.data);
        console.log(data.data.data);
        setError(null);
      } else {
        setError('Водитель не найден');
      }
      setTimeout(setLoading(false), 1000)
    };
    fetchDriver();
  }, [markerId]);

  return (
    <div className="DriverInfo">
      <button className="close-btn" onClick={onClose}>✖</button>
      {loading && <p>Загрузка...</p>}
      {error && <p className="error">{error}</p>}
      {driver && (<>
        <div className='driverInfoBlock'>
          <h2 className='driverInfoBlockHeader'>Информация о водителе</h2>
          <p><strong>Водитель:</strong>{driver.first_name} {driver.middle_name} {driver.last_name}</p>
          <p><strong>Рейтинг:</strong> {driver.rating}</p>
          <p><strong>Требования:</strong> {driver.requirements}</p>
        </div>
        <div className='driverInfoBlock driverCarInfo'>
            <h2 className='driverInfoBlockHeader'>Информация об автомобиле</h2>
            <p><strong>Автомобиль:</strong> {driver.car}</p>
            <p><strong>Цвет:</strong> {driver.color}</p>
            <p><strong>Номер:</strong> {driver.plate_number}</p>
            {driver.schedule && driver.schedule.length > 0 && (
              <div>
                <strong>Расписание:</strong>
                <ul>
                  {driver.schedule.map((s, idx) => (
                    <li key={idx}>{s.day_of_week}: {s.time_to} → {s.time_back}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
      </>
      )}
    </div>
  );
};

export default DriverInfo;